import ExternalLink from 'components/ExternalLink';
import * as React from 'react';
export default {
  ExternalLink,
  React
};